export default __webpack_public_path__ + "static/media/Valka's Illimitable Aegis.d98ad075.jpg";